import * as React from 'react';
import { IMedia, IPagination } from '../../interfaces';
import Axios from 'axios';
import config from '../../config';
import Pagination from '../common/Pagination';
import Serial from '../videoclub/Serial';
import { NavLink } from 'react-router-dom';
import Favorite from '../parts/Favorite';
import { transliterate } from '../../utils/functions';
import Track from '../items/Track';
import { withTranslation } from 'react-i18next';
import i18n from '../../config/i18next';

interface IState {
    albums: IMedia[],
    isLoading: boolean,
    currentPage: number,
    totalPages: number,
    pages: IPagination,
    query: string
}

interface IProps {
    query: string,
    t: any
}

const CancelToken = Axios.CancelToken;
let cancel: any;

class AlbumSearch extends React.Component<IProps, IState> {
    private _isUnmounted: boolean = false;

    constructor(props: any) {
        super(props);

        this.onPageChange = this.onPageChange.bind(this);
    }

    public state: IState = {
        albums: [],
        isLoading: true,
        currentPage: 1,
        totalPages: 1,
        pages: null,
        query: this.props.query
    }

    componentWillReceiveProps(nextProps:any) {
        this.setState({
            query: nextProps.query
        }, this.componentDidMount);
    }

    onPageChange(page: number) {

        this.setState({
            currentPage: page,
            // isLoading: true,
            // albums: []
        }, async () => {
            await this.loadalbums();

        });
    }

    async loadalbums() {
        cancel && cancel();

        try {
            let response = await Axios.get((this.state.currentPage == 1 ? `${config.site}/${i18n.language}/api/album/search?query=${this.state.query}` : `${config.site}/${i18n.language}/api/album/search?query=${this.state.query}&${this.state.pages.pageParam}=${this.state.currentPage}`), {
                cancelToken: new CancelToken(function executor(c) {
                    cancel = c;
                })
            })

            if (!this._isUnmounted) {
                let totalPages = response.data.pages.pageCount;

                this.setState({
                    albums: response.data.albums,
                    isLoading: false,
                    totalPages: totalPages,
                    currentPage: totalPages > 0 ? this.state.currentPage : 1,
                    pages: response.data.pages
                });
            }
        } catch (err) {
            // console.log (err);
        }

    }

    componentDidMount() {
        this.loadalbums();
    }

    componentWillUnmount() {
        this._isUnmounted = true;
    }

    render() {
        const {t} = this.props;

        return (
            <div className="wrap wrap-s mt-0">
                {this.state.isLoading && <div className="carousel-placeholder" />}
                {!this.state.isLoading && this.state.albums.length == 0 && <h3 className="mt-0">{t("Ничего не найдено")}</h3>}

                <div className="box_list clips_list albums_list mt-0">
                    <div className="row">
                        {!this.state.isLoading && this.state.albums.map((track: IMedia, index: number) => {
                            return (
                                <div key={index} className="col-md-3 col-sm-6 col-xs-6">
                                    <div className="item">
                                        <div className="img_box" style={{ borderRadius: 0 }}>
                                            <div className="icons">
                                                <ul>
                                                    <li>
                                                        <Favorite media={track} />
                                                    </li>
                                                    <li>
                                                        <span> </span>
                                                        <NavLink to={"/album/" + transliterate((track.artist ? track.artist.full : "") + "-" + track.name) + "/" + track.media_id}>
                                                            <i className="fa fa-play-circle-o"></i>
                                                        </NavLink>
                                                    </li>
                                                </ul>
                                            </div>
                                            <img style={{ width: "100%", height: "100%" }} src={track.fullImage} alt={track.name} />
                                        </div>
                                        <div className="clearfix"></div>
                                        {track.artist && <div className="seria_info">
                                            <NavLink style={{ color: "#000" }} to={"/singer/" + transliterate(track.artist.full) + "/" + track.artist.person_id}>{(track.artist ? track.artist.full : "")} </NavLink>
                                        </div>}
                                        <NavLink style={{ whiteSpace: "nowrap" }} to={"/album/" + transliterate(track.name) + "/" + track.media_id} className="title" title={track.name}>
                                            {track.name}
                                        </NavLink>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
                {this.state.albums.length > 0 && <Pagination currentPage={this.state.currentPage} totalPages={this.state.totalPages} onChange={this.onPageChange} />}
            </div>
        );
    }
}

export default withTranslation()(AlbumSearch);